if (!customElements.get('product-add-ons')) {
  customElements.define(
    'product-add-ons',
    class ProductAddOns extends HTMLElement {
      constructor() {
        super();
        
        this.querySelectorAll('[data-item-select]').forEach((select) =>
          select.addEventListener('change', this.updateItem.bind(this))
        );
      }

      updateItem(event) {
        event.preventDefault();

        const option = event.target.querySelectorAll('option')[event.target.selectedIndex];
        const content = event.target.closest('[data-bundle-item]');
        content.querySelector('[data-variant-id]').value = option.dataset.value;
        
        const priceRegular = option.dataset.priceRegular;
        const priceCompare = option.dataset.priceCompare;
        
      	const priceElement = content.querySelector('[data-item-price]');
        const priceCompareElement = content.querySelector('[data-item-price-compare]');
        const priceRegularElement = content.querySelector('[data-item-price-regular]');
        
        priceCompare > priceRegular ? priceElement.classList.add('price--on-sale') : priceElement.classList.remove('price--on-sale');
        priceCompareElement.innerHTML = Shopify.Currency.formatMoney(priceCompare, window.moneyFormat);
        priceRegularElement.innerHTML = Shopify.Currency.formatMoney(priceRegular, window.moneyFormat);
      }
    }
  );
}
